import { composeConfigs, PreviewWeb } from '@storybook/preview-web';
    import { ClientApi } from '@storybook/client-api';
    import '/virtual:/@storybook/builder-vite/setup-addons.js';
    import { importFn } from '/virtual:/@storybook/builder-vite/storybook-stories.js';

    const getProjectAnnotations = async () =>
      composeConfigs(await Promise.all([import('@storybook/react/dist/esm/client/docs/config'),
import('@storybook/react/dist/esm/client/preview/config'),
import('@storybook/addon-links/preview.js'),
import('@storybook/addon-docs/preview.js'),
import('@storybook/addon-actions/preview.js'),
import('@storybook/addon-backgrounds/preview.js'),
import('@storybook/addon-measure/preview.js'),
import('@storybook/addon-outline/preview.js'),
import('@storybook/addon-interactions/preview.js'),
import('@storybook/addon-a11y/preview.js'),
import('C:/www/Rocketseat/Ignite/05-design-system/packages/docs/.storybook/preview.js')]));

    const preview = new PreviewWeb();

    window.__STORYBOOK_PREVIEW__ = preview;
    window.__STORYBOOK_STORY_STORE__ = preview.storyStore;
    window.__STORYBOOK_CLIENT_API__ = new ClientApi({ storyStore: preview.storyStore });

    preview.initialize({ importFn, getProjectAnnotations });
    
    if (import.meta.hot) {
      import.meta.hot.accept('/virtual:/@storybook/builder-vite/storybook-stories.js', (newModule) => {
      // importFn has changed so we need to patch the new one in
      preview.onStoriesChanged({ importFn: newModule.importFn });
      });

    import.meta.hot.accept(["@storybook/react/dist/esm/client/docs/config","@storybook/react/dist/esm/client/preview/config","@storybook/addon-links/preview.js","@storybook/addon-docs/preview.js","@storybook/addon-actions/preview.js","@storybook/addon-backgrounds/preview.js","@storybook/addon-measure/preview.js","@storybook/addon-outline/preview.js","@storybook/addon-interactions/preview.js","@storybook/addon-a11y/preview.js","C:/www/Rocketseat/Ignite/05-design-system/packages/docs/.storybook/preview.js"], ([...newConfigEntries]) => {
      const newGetProjectAnnotations =  () => composeConfigs(newConfigEntries);

      // getProjectAnnotations has changed so we need to patch the new one in
      preview.onGetProjectAnnotationsChanged({ getProjectAnnotations: newGetProjectAnnotations });
    });
  };